import { urls } from "@config/urls";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function StatusButtons() {
  const { t } = useTranslation("status");
  return (
    <div className="flex flex-col justify-center gap-6 md:flex-row">
      <Link
        to={urls.home}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-lg border border-blue bg-blue px-4 py-3 text-center font-bold text-white transition-all duration-300 hover:opacity-80">
        {t("backToHome")}
      </Link>
      <Link
        to={urls.requestHelp}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-lg border border-blue bg-transparent px-4 py-3 text-center font-bold text-blue transition-all duration-300 hover:bg-blue hover:text-white">
        {t("requestHelp")}
      </Link>
    </div>
  );
}
